import { RoleManagementRoutingModule } from './role-management-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RoleManagementComponent } from './role-management.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [RoleManagementComponent],
  imports: [
    CommonModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    RoleManagementRoutingModule,
    SharedModule
  ]
})
export class RoleManagementModule { }
